module.exports = __webpack_public_path__ + "img/1.6898f406.webp";